import { fetchDocFileObjectUrl } from './api';
import { toast } from '../components/Toast';

// Opens a document's scan in a new tab without leaving the page — the
// report drill-downs' linked document numbers (top products, by
// classification). The scan is fetched with the user's login
// (fetchDocFileObjectUrl), so the tab can only be pointed at it AFTER a
// request, and a window.open after an `await` is outside the click: Safari
// (iPad — these drill-downs render from 641px) blocks it silently. So, as
// command-center's openPendingTab does, the tab is opened blank inside the
// click, its opener cut (what 'noopener' would do), pointed at the scan once
// it arrives, and closed on failure. The blob URL is not revoked: the new tab
// owns it (ReviewDocPane's choice too).
export async function openScanInNewTab(filePath) {
  const tab = window.open('', '_blank');
  if (tab) tab.opener = null;
  try {
    const url = await fetchDocFileObjectUrl(filePath);
    if (tab) tab.location.href = url;
    else window.open(url, '_blank', 'noreferrer');
  } catch (err) {
    tab?.close();
    console.error('[open-scan]', err);
    toast('שגיאה בטעינת המסמך', 'error');
  }
}
